package com.gsb.vyapar.bhagya

import androidx.compose.runtime.*
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.platform.LocalFontFamilyResolver
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.platform.Font
import androidx.compose.ui.window.ComposeViewport
import com.gsb.vyapar.bhagya.interactor.manager.StateManager.getState
import com.gsb.vyapar.bhagya.mqtt.MQTTManagerWeb
import com.gsb.vyapar.bhagya.presentation.bottomsheet.util.hideBottomSheet
import com.gsb.vyapar.bhagya.presentation.navigation.util.popView
import com.gsb.vyapar.bhagya.util.PlatformType
import com.gsb.vyapar.bhagya.util.getUserAgentJs
import com.gsb.vyapar.bhagya.util.showExitPopup
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.await
import org.jetbrains.skiko.wasm.onWasmReady
import org.khronos.webgl.Int8Array
import org.w3c.fetch.Response
import kotlin.js.*
import org.w3c.dom.DocumentReadyState
import org.w3c.dom.LOADING

private val notoColorEmoji = "./NotoColorEmoji.ttf"
private val notoKurrent = "./GoNotoKurrent-Regular.ttf"

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    onWasmReady {
        // Make touch events passive so scrolling isn’t blocked
        val passive = js("{ passive: true }")
        document.addEventListener("touchstart", { /* no-op */ }, passive)
        document.addEventListener("touchmove", { /* no-op */ }, passive)

        // Initialize MQTT bridge
        val mqttManagerWeb = MQTTManagerWeb()

        // Start when DOM is ready to ensure body exists
        val startApp: () -> Unit = {
            // Use ComposeViewport (recommended) instead of deprecated CanvasBasedWindow
            ComposeViewport(document.body!!) {
                val fontFamilyResolver = LocalFontFamilyResolver.current
                var fontsLoaded by remember { mutableStateOf(false) }
                if (fontsLoaded) {
                    App(window.location.href)
                }
                LaunchedEffect(Unit) {
                    listOf(
                        "NotoColorEmoji" to notoColorEmoji,
                        "GoNotoKurrent" to notoKurrent,
                    ).forEach { (fontName, fontPath) ->
                        val fontBytes = loadFontBytes(fontPath)
                        val fontFamily = FontFamily(listOf(Font(fontName, fontBytes)))
                        fontFamilyResolver.preload(fontFamily)
                    }
                    fontsLoaded = true
                }
            }

            window.history.pushState(null, "", window.location.href)
            window.onpopstate = { event ->
                event.preventDefault()
                if (getState().navView != null) {
                    popView()
                    window.history.pushState(null, "", window.location.href)
                } else if (getState().bottomSheetView != null) {
                    hideBottomSheet()
                    window.history.pushState(null, "", window.location.href)
                } else {
                    if (getUserAgentJs() == PlatformType.ANDROID) {
                        showExitPopup {
                            if (it) {
                                window.history.back()
                            } else {
                                window.history.pushState(null, "", window.location.href)
                            }
                        }
                    }
                }
            }
        }

        val maybeOnWasmReady: dynamic = js("globalThis.onWasmReady")
        if (maybeOnWasmReady != undefined) {
            maybeOnWasmReady {
                if (document.readyState == DocumentReadyState.LOADING) {
                    document.addEventListener("DOMContentLoaded", { startApp() })
                } else {
                    startApp()
                }
            }
        } else {
            if (document.readyState == DocumentReadyState.LOADING) {
                document.addEventListener("DOMContentLoaded", { startApp() })
            } else {
                startApp()
            }
        }
    }
}

suspend fun loadFontBytes(url: String): ByteArray {
    val buffer = window.fetch(url).await<Response>().arrayBuffer().await()
    return Int8Array(buffer).unsafeCast<ByteArray>()
}
